module.exports = __webpack_public_path__ + "static/media/empty-cart-error-min.510bd7dc.jpg";